import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Flex, FormControl, FormLabel, Input, Text } from '@chakra-ui/react'
import { useImmer } from 'use-immer'
import { updateProject } from 'api'
import { useAppContext } from 'hooks/useAppContext'

export const ProjectDetailGenericCustomer = ({ project, reload, ...rest }) => {
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLocked, setIsLocked] = useState(true)
  const [customer, setCustomer] = useImmer({
    customerCompany: '',
    customerName: '',
    customerPhone: '',
    customerEmail: '',
    customerAddress: '',
    customerCity: '',
    customerState: '',
    customerZip: '',
    receiveAutomaticEmails: true
  })

  useEffect(() => {
    setCustomer({
      customerCompany: project?.customerCompany || '',
      customerName: project?.customerName || '',
      customerPhone: project?.customerPhone || '',
      customerEmail: project?.customerEmail || '',
      customerAddress: project?.customerAddress || '',
      customerCity: project?.customerCity || '',
      customerState: project?.customerState || '',
      customerZip: project?.customerZip || '',
      receiveAutomaticEmails: project?.receiveAutomaticEmails !== false && project?.receiveAutomaticEmails !== 0
    })
  }, [project])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    try {
      await updateProject(project?.id, customer)
      setIsSubmitting(false)
      createToast('success', 'Success', 'Customer detail updated.')
      reload()
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  const handleChange = (e) => {
    setCustomer(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  return (
    <Box {...rest}>
      <form onSubmit={handleSubmit}>
        <FormControl isRequired>
          <FormLabel>Company</FormLabel>
          <Input type="text" name="customerCompany" value={customer.customerCompany} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Name</FormLabel>
          <Input type="text" name="customerName" value={customer.customerName} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Phone</FormLabel>
          <Input type="text" name="customerPhone" value={customer.customerPhone} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Email</FormLabel>
          <Input type="text" name="customerEmail" value={customer.customerEmail} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <FormControl mt={2} mb={2}>
          <Checkbox
            isChecked={!!customer.receiveAutomaticEmails}
            isDisabled={isLocked}
            onChange={(e) => {
              setCustomer(draft => {
                draft.receiveAutomaticEmails = e.target.checked
              })
            }}
          >
            <Text fontSize="sm">Automatic emails</Text>
          </Checkbox>
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Address</FormLabel>
          <Input type="text" name="customerAddress" value={customer.customerAddress} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>City</FormLabel>
          <Input type="text" name="customerCity" value={customer.customerCity} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>State</FormLabel>
          <Input type="text" name="customerState" value={customer.customerState} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Zip</FormLabel>
          <Input type="text" name="customerZip" value={customer.customerZip} onChange={handleChange} isReadOnly={isLocked} />
        </FormControl>
        <Flex justifyContent="flex-end" gap={4} mt={4}>
          <Button
            size="md"
            colorScheme="gray"
            onClick={() => setIsLocked(!isLocked)}
          >
            {isLocked ? 'Unlock' : 'Lock'}
          </Button>
          <Button
            type="submit"
            size="md"
            colorScheme="blue"
            isLoading={isSubmitting}
          >
            Save
          </Button>
        </Flex>
      </form>
    </Box>
  )
}

ProjectDetailGenericCustomer.propTypes = {
  project: PropTypes.object,
  reload: PropTypes.func
}
